/**
 * Payment Status Utility
 * Maps quote payment statuses to simplified 3-state system
 */

/**
 * Get simplified payment status for a quote
 * @param {Object} quote - Quote object with payments data
 * @returns {Object} Status object with label, color, variant, and emoji
 */
export const getPaymentStatus = (quote) => {
  const status = quote?.payments?.paymentStatus || "no_payment";

  if (status === "deposit_paid") {
    return {
      label: "Paid",
      emoji: "🟢",
      color: "success",
      variant: "filled",
      status: "paid",
    };
  }

  if (status === "awaiting_payment" || status === "proof_received") {
    return {
      label: "Pending",
      emoji: "🟠",
      color: "warning",
      variant: "outlined",
      status: "pending",
    };
  }

  return {
    label: "Unpaid",
    emoji: "⚪",
    color: "default",
    variant: "outlined",
    status: "unpaid",
  };
};

/**
 * Get payment status badge configuration for Ant Design Tag
 * @param {Object} quote - Quote object with payments data
 * @returns {Object} Tag configuration with color and text
 */
export const getPaymentStatusBadge = (quote) => {
  const status = getPaymentStatus(quote);
  return {
    color: status.color === "success" ? "green" : status.color === "warning" ? "gold" : "default",
    text: `${status.emoji} ${status.label}`,
  };
};

